import { NotFound } from 'modules/NotFound'
import { Navigate, Route, Routes } from 'react-router'
import { AvailabilityConstraints } from '../../../components/AvailabilityConstraints'
import { RouteParameters } from '../../../constants'
import { Availability } from '../../Availability'

const { RESOURCE_ID: resourceId } = RouteParameters

const Resources = () => (
  <Routes>
    <Route element={<Navigate replace to={`availability-constraints`} />} path={`:${resourceId}/`} />
    <Route element={<Availability />} path={`:${resourceId}/availability/*`} />
    <Route element={<AvailabilityConstraints />} path={`:${resourceId}/availability-constraints/*`} />
    <Route element={<NotFound />} path="*" />
  </Routes>
)

export { Resources }
